// =====================================================================================
// FILE: src/constants/categories.js
// =====================================================================================

export const OUT_OF_GAME_CATEGORY_ORDER = [
  "Robbie Flowers",
  "Ponsford Stage",
  "Disney Entitlement [NRH]",
  "MCG Entitlements",
  "Interchange Bench",
  "DJ Booth",
  "Club Song Home",
  "Club Song Away",
  "Pre-Game",
  "Match Holding",
  "Quarter Time",
  "Half Time",
  "Three Quarter Time",
  "Post Game [Wins]",
  "Post Game [Lose]",
  "Allocations",
  "Bonus Allocations",
  "Team List",
];

export const IN_GAME_CATEGORY_ORDER = [
  "In-Game Triggers",
  "AFL Marketing",
  "Pre-Game",
  "Interchange Bench",
  "DJ Booth",
  "Goal Celebration",
  "In Game Club Commercial",
  "In Game Club Sponsors",
  "Allocations",
  "Bonus Allocations",
  "Team List",
];

export const IPTV_CATEGORY_ORDER = [
  "General Content All Areas",
  "External Gates",
  "Stadium Square",
  "Function Rooms",
  "Function Room LED Walls",
  "AFL Marketing [Victory]",
  "In Game Club Sponsors",
  "Changerooms",
  "External Totems",
  "Players Races [Home]",
  "Players Races [Away]",
];

export const LED_CATEGORY_ORDER = ["Allocations", "Bonus Allocations"];
export const TEAM_LIST_CATEGORY_ORDER = ["Team List"];

export const IPTV_TIMING_OPTIONS = [
  "Pre-Match",
  "During ALL Match",
  "During 1st Quarter Time",
  "During Half Time",
  "During Three Quarter Time",
  "Post-Match",
];

// IPTV categories managed by operators only (hidden from MatchFlow Builder / club view)
// These are physical location entitlements filled by operators at the venue
export const IPTV_OPERATOR_ONLY_PATTERNS = [
  '[AFL Marketing]',
  '[Disney]',
  '[Victory]',
];

// Exact-match operator-only IPTV categories (add specific names here)
export const IPTV_OPERATOR_ONLY_CATEGORIES = [
  'AFL Marketing [Victory]',
  'Aisle 31 [AFL Marketing]',
  'Gate 4 [Disney]',
  'Gate 6 [Disney]',
  'Gate 8 [AFL Marketing]',
  'Gate 9 [AFL Marketing]',
];

// Helper: check if an IPTV category is operator-only
export const isIptvOperatorOnly = (category) => {
  if (!category) return false;
  if (IPTV_OPERATOR_ONLY_CATEGORIES.includes(category)) return true;
  return IPTV_OPERATOR_ONLY_PATTERNS.some(pattern => category.includes(pattern));
};

export const IPTV_LOCATION_OPTIONS = [
  "Harrison Room",
  "Ryder Room",
  "Hassett Room",
  "Miller Room",
  "Yarra Park Room",
  "Gate 1",
  "Gate 4",
  "Gate 5",
  "Gate 6",
  "Gate 7",
  "Victory Room",
  "Victory C-E Screens",
  "Quill Room",
  "Quill Room Wall LED",
  "Parker Room",
  "Rogers Room",
  "Skyline Room",
  "Horizon Room",
  "Danvers Room",
  "Stark",
];
